import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TruckOwnerService } from "../truck-owner.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-view-driver-route",
  templateUrl: "./view-driver-route.component.html",
  styleUrls: ["./view-driver-route.component.css"],
})
export class ViewDriverRouteComponent implements OnInit {
  driverData: any;
  driver_Payment_Details: any = [];
  driver_Trip_History: any = [];
  driver_View_Notes: any = [];
  driverTax: any = [];
  driver_Trip_Details: any = [];
  transporter_details: any[] = [];
  calculatedTax: any = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matdialogRef: MatDialogRef<ViewDriverRouteComponent>,
    private services: TruckOwnerService,
    private snackBar: MatSnackBar
  ) {
    this.driverData = data;
    this.transporter_details = this.driverData?.truckownerPaymentInfo || [];

    if (data?.trip_payment_info?.[0]?.price_details?.payment_history) {
      this.driver_Payment_Details.push(
        data.trip_payment_info[0].price_details.payment_history
      );
    }
    if (data?.trip_details?.[0]?.driver_trip_history) {
      this.driver_Trip_History = data.trip_details[0].driver_trip_history;
    }
    if (data?.trip_details?.[0]?.driver_notes) {
      this.driver_View_Notes = data.trip_details[0].driver_notes;
    }
    if (data?.transporter_tax_details && data.transporter_tax_details.length > 0) {
      this.driverTax = data.transporter_tax_details;
    } else if (data?.tax_details && data.tax_details.length > 0) {
      this.driverTax = data.tax_details;
    } else if (data?.trip_payment_info?.[0]?.price_details?.tax_details) {
      this.driverTax = data.trip_payment_info[0].price_details.tax_details;
    }

    if (data?.driver_route_history) {
      this.driver_Trip_Details = data.driver_route_history;
    }

    if (this.driverData?.route_fare && this.driverTax?.length > 0) {
      let taxValue = 0;
      for (const tax of this.driverTax) {
        if (tax.tax_type === "percentage" || tax.tax_type === "percent") {
          taxValue += (this.driverData.route_fare * parseFloat(tax.tax_deduction)) / 100;
        } else if (tax.tax_type === "amount") {
          taxValue += parseFloat(tax.tax_deduction);
        }
      }
      this.calculatedTax = taxValue;
    }
  }

  ngOnInit(): void {}

  close() {
    this.matdialogRef.close();
  }

  cancelDRO(id: string): void {
    let token = sessionStorage.getItem("to_token");
    const cancelPayload = {
      reason: "Cancelled by transporter from DRO panel",
      cancelled_by: "transporter",
    };
    this.services.cancelDro(cancelPayload, token, id).subscribe({
      next: (response: any) => {
        if (response.status === 200) {
          this.matdialogRef.close();
          location.reload();
          this.snackBar.open(response.body?.message || "DRO cancelled", "Success", {
            duration: 5000,
          });
        }
      },
      error: (error: any) => {
        this.snackBar.open(error.error?.message || "DRO Cancellation failed", "Fail", {
          duration: 5000,
        });
      }
    });
  }

  getPaymentLabel(index: number): string {
    const labels = ["1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th"];
    return labels[index - 1] || `${index}th`;
  }
}
